module.exports = __webpack_public_path__ + "img/icon11.c29178ac.svg";